import urlDataNames from '@/helpers/urlDataNames.json';

export function target() {
  return true; // all modules
}

export function migrate() {
  if (this.module === 'PromoMulti') {
    delete this.data.buttonLinks;
    delete this.data.page;
    delete this.data.groupPage;
  }

  if (this.module === 'PromoSingle') {
    delete this.data.dynamicLink;
    delete this.data.page;
  }

  if (this.module === 'PromoList') {
    delete this.data.filterBy;
    delete this.data.dynamicLink;
    delete this.data.page;
  }

  Object.entries(this.data).forEach(([key, value]) => {
    if (
      urlDataNames.includes(key) &&
      typeof value !== 'undefined' &&
      value.type === 'dynamicPage'
    ) {
      this.data[key] = {
        type: 'externalLink',
        value: '',
        openInNewTab: true,
      };
    }
  });
}
